import { queryOptions } from "@tanstack/react-query";
import instance, { ApiUrl } from "./axiosInstance";

export enum FeatureFlagName {
  IsWasteStationNotificationEnabled = "isWasteStationNotificationEnabled",
}

export enum FeatureFlagQueryKey {
  CheckFlag = "check-feature-flag",
}

export const checkFeatureFlag = (name: FeatureFlagName) =>
  queryOptions({
    queryKey: [FeatureFlagQueryKey.CheckFlag, name],
    queryFn: async (): Promise<boolean> =>
      (await instance.get(`${ApiUrl.FeatureFlag}/${name}`)).data,
  });
